import { Container, SceneObject } from '@cgs/wge';
import {
  ComponentNames,
  EntitiesEngine,
  Entity,
  IconValuesSystems,
  ISlotGameEngineProvider,
  T_ISlotGameEngineProvider,
  T_MultiSceneIconWithValuesProvider,
} from '@cgs/machines';
import { CorsicaIconWithValuesProvider } from './corsica-icon-with-values.provider';
import { IconValueDescription } from './corsica-icon-values.types';
import { drawIconValue } from './corsica-icon-values.helper';

export class CorsicaIconValuesSystems extends IconValuesSystems {
  private readonly _container: Container;
  private _iconPriceComponent: CorsicaIconWithValuesProvider | null = null;
  private _engine: EntitiesEngine | null = null;

  constructor(container: Container) {
    super();
    this._container = container;
  }

  private get engine(): EntitiesEngine {
    if (!this._engine) {
      const reelsEngine =
        this._container.resolve<ISlotGameEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;
      this._engine = reelsEngine.entityEngine;
    }
    return this._engine;
  }

  private get iconPriceComponent(): CorsicaIconWithValuesProvider {
    if (!this._iconPriceComponent) {
      this._iconPriceComponent = this._container.resolve<CorsicaIconWithValuesProvider>(
        T_MultiSceneIconWithValuesProvider
      );
    }
    return this._iconPriceComponent;
  }

  public renderIconValue(entity: Entity): void {
    const valueDescription = entity.get<IconValueDescription>(
      this.engine.getComponentIndex(ComponentNames.IconValue)
    );

    if (!valueDescription) {
      return;
    }


    if (entity.get<boolean>(this.engine.getComponentIndex(ComponentNames.NeedUpdate))) {
      entity.addComponent(ComponentNames.NeedUpdate, false);

      const iconNode = entity.get<SceneObject>(
        this.engine.getComponentIndex(ComponentNames.IconNode)
      );

      if (!iconNode) {
        return;
      }

      drawIconValue(iconNode, valueDescription);
    }
  }

  public placementIconValue(entity: Entity): void {
    const relocatedFlagIndex = this.engine.getComponentIndex(ComponentNames.RelocatedFlag);
    const relocated = entity.get<number>(relocatedFlagIndex);

    if (relocated === 0) {
      return;
    }

    const posInReelIndex = this.engine.getComponentIndex(ComponentNames.PositionInReel);
    const speedFlagIndex = this.engine.getComponentIndex(ComponentNames.Speed);
    const drawableIdIndex = this.engine.getComponentIndex(ComponentNames.DrawableIndex);

    const reelIndex = this.engine.getComponentIndex(ComponentNames.ReelIndex);
    const reel = entity.get<number>(reelIndex);

    if (entity.hasComponent(posInReelIndex)) {
      const posInReel = entity.get<number>(posInReelIndex);

      const valueDescription = this.iconPriceComponent.getValueDescription(reel, posInReel);

      if (valueDescription) {
        entity.addComponent(ComponentNames.IconValue, valueDescription);
        entity.addComponent(ComponentNames.NeedUpdate, true);
      } else if (entity.hasComponent(speedFlagIndex)) {
        const drawId = entity.get<number>(drawableIdIndex);
        const valueDescriptionFake = this.iconPriceComponent.getFakeValueDescription(
          reel,
          -1,
          drawId
        );
        if (valueDescriptionFake) {
          entity.addComponent(ComponentNames.IconValue, valueDescriptionFake);
          entity.addComponent(ComponentNames.NeedUpdate, true);
        }
      }
    } else if (entity.hasComponent(speedFlagIndex)) {
      const drawId = entity.get<number>(drawableIdIndex);
      const valueDescription = this.iconPriceComponent.getFakeValueDescription(reel, -1, drawId);
      if (valueDescription) {
        entity.addComponent(ComponentNames.IconValue, valueDescription);
        entity.addComponent(ComponentNames.NeedUpdate, true);
      }
    }
  }
}
